module.exports = __webpack_public_path__ + "img/00014.b79c61b0.webp";